// Chamadas da tela Connect. Os mesmos endpoints e formatos da tela antiga (RelatorioVendas.js).
import axios from 'axios';
import { REQUEST_URL } from '../../config/urls';

export function aplicarToken() {
  const token = sessionStorage.getItem('token');
  if (token) axios.defaults.headers.common['Authorization'] = token;
  else delete axios.defaults.headers.common['Authorization'];
}

// Tira parâmetros vazios, como a tela antiga fazia antes de cada chamada
export function limparParametros(params) {
  const limpos = { ...params };
  Object.keys(limpos).forEach(chave => {
    const valor = limpos[chave];
    if (valor === '' || valor === null || valor === undefined || (Array.isArray(valor) && valor.length === 0)) {
      delete limpos[chave];
    }
  });
  return limpos;
}

const SEM_CACHE = { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '0' };

export function novoCancelamento() {
  return axios.CancelToken.source();
}

export function foiCancelado(erro) {
  return axios.isCancel(erro);
}

// Página de cursos (limit = cursos por página)
export function buscarCursos(params, cancelToken) {
  aplicarToken();
  return axios.get(`${REQUEST_URL}/relatorio-vendas?t=${Date.now()}`, {
    params: limparParametros({ ...params, includeSummary: 'false' }),
    headers: SEM_CACHE,
    timeout: 120000,
    cancelToken
  }).then(res => res.data);
}

export function buscarResumo(params, cancelToken) {
  aplicarToken();
  return axios.get(`${REQUEST_URL}/relatorio-vendas/summary?t=${Date.now()}`, {
    params: limparParametros(params),
    headers: SEM_CACHE,
    cancelToken
  }).then(res => res.data);
}

export function buscarOpcoesFiltro() {
  aplicarToken();
  return axios.get(`${REQUEST_URL}/filtros`).then(res => res.data);
}

// Todas as turmas de um curso, sem os filtros da tela (para o painel do curso)
export function buscarCursoCompleto({ nomeintituicao, nomecurso, nomecidade }) {
  aplicarToken();
  return axios.get(`${REQUEST_URL}/relatorio-vendas?t=${Date.now()}`, {
    params: limparParametros({
      page: 1,
      limit: 200,
      instituicoes: [nomeintituicao],
      cursos: [nomecurso],
      cidades: nomecidade ? [nomecidade] : [],
      includeSummary: 'false'
    }),
    headers: SEM_CACHE,
    timeout: 120000
  }).then(res => res.data);
}

export function buscarSolicitacoes() {
  aplicarToken();
  return axios.get(`${REQUEST_URL}/solicitacoes-vinculacao?timestamp=${Date.now()}`).then(res => res.data || []);
}

export function enviarSolicitacao(dados) {
  const token = sessionStorage.getItem('token');
  return axios.post(`${REQUEST_URL}/solicitacoes-vinculacao`, dados, {
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
  });
}

export function responderSolicitacao(id, aprovado, justificativa) {
  aplicarToken();
  return axios.put(`${REQUEST_URL}/solicitacoes-vinculacao/${id}`, {
    status: aprovado ? 'aprovado' : 'rejeitado',
    justificativa: aprovado ? null : justificativa
  });
}

export function prorrogarPrioridade(idSolicitacao) {
  aplicarToken();
  return axios.post(`${REQUEST_URL}/prioridade/prorrogar/${idSolicitacao}`).then(res => res.data);
}

export function estenderPrazoContato(idCursoInst, anoForm) {
  aplicarToken();
  return axios.put(`${REQUEST_URL}/extender-range`, { id_curso_inst: idCursoInst, ano: anoForm }).then(res => res.data);
}

export function gravarVendedorDaTurma(idCursoInst, anoForm, vendedor) {
  aplicarToken();
  return axios.put(`${REQUEST_URL}/relatorio-vendas/vendedor`, {
    id_curso_inst: idCursoInst,
    vendedorId: vendedor.id,
    vendedorNome: vendedor.nome,
    ano: anoForm
  });
}

export function buscarDadosExportacao(params) {
  aplicarToken();
  return axios.get(`${REQUEST_URL}/relatorio-vendas/exportar`, {
    params: limparParametros(params),
    headers: { 'Cache-Control': 'no-cache' },
    timeout: 120000
  }).then(res => res.data.data || []);
}
